<div class="events-panel">
  <div class="btns-filters">
    <div class="filters-with-clear">
      <div class="search-and-filter">
        <div class="buscador-event container-form d-flex align-items-center borderInput">
          <i class="fal fa-search search-icon pointer-in" (click)="searchEvents(searchInput.value)"></i>
          <input #searchInput class="input-custom w-100" type="text" placeholder="Buscar evento" [ngModel]="searchText"
            (input)="searchEvents(searchInput.value)">
        </div>
        <div class="btn-create btn-filter m-0" (click)="toggleFilters()">
          <i class="fal fa-sliders"></i>
          <p class="m-0">Filtrar</p>
        </div>
      </div>

      <!-- Botón limpiar filtros -->
      <button class="btn-clear-filters" *ngIf="searchText || placeSelected || datesRange || statusFilter" (click)="clearFilters()">
        <i class="fal fa-times"></i>
        <span>Quitar filtros</span>
      </button>
    </div>

    <div class="btns-create" *ngIf="!idVenue && allowCreate">
      <div class="btn-create m-0" (click)="openCreateEvent()">
        <i class="fal fa-plus-circle"></i>
        <p class="m-0">Crear evento</p>
      </div>
    </div>
  </div>

  <!-- Filtros Desktop -->
  <div class="container-filters flex-row desktop-filters" *ngIf="activeFilters">
    <!-- Espacio -->
    <div *ngIf="!idVenue && placesEnabled?.length > 1">
      <mat-form-field appearance="fill" class="select-filter-panel">
        <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Todos los espacios"
          [(ngModel)]="placeSelected" disableOptionCentering="false" (ngModelChange)="changePlaceFilter()">
          <mat-option [value]="null">Todos los espacios</mat-option>
          <mat-option *ngFor="let place of placesEnabled" [value]="place.id">
            <span>{{place.name}}</span>
          </mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
    </div>
    <!-- Fecha -->
    <div class="flex-column">
      <mat-form-field appearance="fill" class="select-filter-panel pointer-in"
        (click)="openDatePicker=!openDatePicker">
        <input matInput placeholder="Fecha" class="input-date pointer-in" readonly [(ngModel)]="stringDate">
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
      <div class="padding-option">
        <app-custom-calendar-panel [datesRange]="datesRange" [openDatePicker]="openDatePicker"
          [disableFutureDates]="false"
          (closeEvent)="openDatePicker = false" (datesEvent)="selectDates($event)"></app-custom-calendar-panel>
      </div>
    </div>
    <div>
      <mat-form-field appearance="fill" class="select-filter-panel">
        <mat-select class="text-black" panelClass="selectPanelControl" placeholder="Estado"
          [(ngModel)]="statusFilter" disableOptionCentering="false" (closed)="updateEvents()">
          <mat-option *ngFor="let status of statusOptions" [value]="status.id">
            <span>{{status.name}}</span>
          </mat-option>
        </mat-select>
        <mat-select-trigger matSuffix style="vertical-align: middle;">
          <i class="fal fa-angle-down pointer-in"></i>
        </mat-select-trigger>
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="loadingPage" class="container-lottie">
    <div class="loading-container">
      <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
        containerClass="loading-box"></ng-lottie>
    </div>
  </div>

  <!-- Vista tabla para desktop -->
  <div #containerScroll class="table-events table-panel multiple-lines desktop-view" *ngIf="loaded"
    (scroll)="isScrolledInfinityView($event)">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z28" matSort (matSortChange)="sortData($event)">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="d-lg-none">Acciones</th>
        <td mat-cell *matCellDef="let event" class="d-lg-none">
          <i class="fal fa-ellipsis-vertical icon-option" (click)="openEvent(event)"></i>
        </td>
      </ng-container>
      <ng-container matColumnDef="titulo">
        <th mat-header-cell *matHeaderCellDef><b>Evento</b></th>
        <td mat-cell *matCellDef="let event" (click)="openEvent(event)">
          <img fallimg class="image-table" src="{{urlImages+event.image_url}}">
          <span class="link-titulo">{{event.title}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="qr">
        <th mat-header-cell *matHeaderCellDef><b>QR</b></th>
        <td mat-cell *matCellDef="let event">
          <i class="fal fa-qrcode icon-option icon-qr" (click)="dowloadQR(event)"></i>
        </td>
      </ng-container>
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef><b>Lugar</b></th>
        <td mat-cell *matCellDef="let event" (click)="openEvent(event)">
          <span [class.placeText]="event.space">{{event.space ? event.space?.name :
            event.address}}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="fecha">
        <th mat-header-cell *matHeaderCellDef><b>Fecha y hora</b></th>
        <td mat-cell *matCellDef="let event" (click)="openEvent(event)">
          <i class="fa-light fa-calendar"></i>
          {{event.start_date | date:'dd MMM y':'+0000' | titlecase }}
          <span *ngIf="event.end_date && event.start_date !== event.end_date"> - {{event.end_date | date:'dd MMM
            y':'+0000' | titlecase }}</span>
          <span *ngIf="!event.end_date || event.start_date == event.end_date"> | {{event.start_date |
            date:'HH:mm':'+0000' }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="vendidas" *ngIf="!draft">
        <th mat-header-cell *matHeaderCellDef><b>Vendidas</b></th>
        <td mat-cell *matCellDef="let event" (click)="openEvent(event)">
          <div *ngIf="!event.draft">
            <span *ngIf="event.external">-</span>
            <ng-container *ngIf="!event.external">
              <span>{{event.purchase <= 0 ? 0 : event.purchase}}</span>
              <span *ngIf="event.sessions?.length == 1">{{' / '}}</span>
              <span *ngIf="event.sessions?.length == 1">{{event.space && event.use_map ? event.space?.capacity :
                event.capacity}}</span>
            </ng-container>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="precio">
        <th mat-header-cell *matHeaderCellDef><b>Desde</b></th>
        <td mat-cell *matCellDef="let event" (click)="openEvent(event)">
          <span *ngIf="event.external">-</span>
          <span *ngIf="!event.external">{{event.custom_from_price ?? event.from_price}} €</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef><b>Estado</b></th>
        <td mat-cell *matCellDef="let event">
          <div class="d-flex align-items-center status-event" [style.color]="getStatus(event).color">
            <i class="fa-solid fa-circle"></i>
            <span>{{getStatus(event).status}}</span>
          </div>
          <span *ngIf="(profile?.citylok || profile?.admin) && !event.draft"
            class="ms-2" [matMenuTriggerFor]="statusMenu"
            style="cursor: pointer; color: #FF4D80;">
            <i [class.fa-spin]="loadingStateChange[event.id]" class="fa-light fa-ellipsis-horizontal"></i>
          </span>
          <mat-menu #statusMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="onPanelStopSales(event)"
              *ngIf="event.active !== false && event.active_sales !== false && event.sold_out !== true && event.cancelled !== true"
              [disabled]="loadingStateChange[event.id]">
              <i class="fa-light fa-pause"></i> Parar ventas
            </button>
            <button mat-menu-item (click)="onPanelSoldOut(event)"
              *ngIf="event.active !== false && event.active_sales !== false && event.sold_out !== true && event.cancelled !== true"
              [disabled]="loadingStateChange[event.id]">
              <i class="fa-light fa-users"></i> Aforo completo
            </button>
            <button mat-menu-item (click)="onPanelCancel(event)"
              *ngIf="event.cancelled !== true && event.active !== false"
              [disabled]="loadingStateChange[event.id]">
              <i class="fa-light fa-ban"></i> Cancelar
            </button>
            <button mat-menu-item (click)="onPanelDeactivate(event)"
              *ngIf="event.active !== false && event.cancelled !== true"
              [disabled]="loadingStateChange[event.id]">
              <i class="fa-light fa-eye-slash"></i> Desactivar
            </button>
            <button mat-menu-item (click)="onPanelRestore(event)"
              *ngIf="event.active === false || event.sold_out === true || event.active_sales === false || event.cancelled === true"
              [disabled]="loadingStateChange[event.id]">
              <i class="fa-light fa-redo"></i> Restaurar
            </button>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div class="pagination-component">
      <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
        <div>
          <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
        </div>
      </div>
    </div>
  </div>

  <!-- Vista tarjetas para móvil -->
  <div #containerScrollMobile class="mobile-view events-cards" *ngIf="loaded" (scroll)="isScrolledInfinityView($event)">
    <div class="event-card" *ngFor="let event of dataSource.filteredData" (click)="openEvent(event)">
      <div class="card-header">
        <img fallimg class="event-image" src="{{urlImages+event.image_url}}">
        <div class="card-actions">
          <i class="fal fa-qrcode icon-action" (click)="dowloadQR(event); $event.stopPropagation()"></i>
        </div>
      </div>
      <div class="card-content">
        <h3 class="event-title">{{event.title}}</h3>
        <div class="event-info">
          <div class="info-row">
            <i class="fal fa-map-marker-alt"></i>
            <span class="info-text">{{event.space ? event.space?.name : event.address}}</span>
          </div>
          <div class="info-row">
            <i class="fa-light fa-calendar"></i>
            <span class="info-text">
              {{event.start_date | date:'dd MMM y':'+0000' | titlecase }}
              <span *ngIf="event.end_date && event.start_date !== event.end_date"> - {{event.end_date | date:'dd MMM
                y':'+0000' | titlecase }}</span>
              <span *ngIf="!event.end_date || event.start_date == event.end_date"> | {{event.start_date |
                date:'HH:mm':'+0000' }}</span>
            </span>
          </div>
          <div class="info-row" *ngIf="!draft && !event.draft">
            <i class="fal fa-ticket"></i>
            <span class="info-text">
              Vendidas:
              <ng-container *ngIf="event.external; else internalSales"> - </ng-container>
              <ng-template #internalSales>
                {{event.purchase <= 0 ? 0 : event.purchase}}
                <span *ngIf="event.sessions?.length == 1"> /
                  {{event.space && event.use_map ? event.space?.capacity : event.capacity}}</span>
              </ng-template>
            </span>
          </div>
          <div class="card-footer row">
            <div class="col-12 d-flex justify-content-end">
              <div class="status-badge col-12" [style.background-color]="getStatus(event).color">
                <span>{{getStatus(event).status}}</span>
                <span *ngIf="(profile?.citylok || profile?.admin) && !event.draft"
                  class="ms-2" [matMenuTriggerFor]="statusMenuMobile"
                  style="cursor: pointer;">
                  <i [class.fa-spin]="loadingStateChange[event.id]" class="fa-light fa-ellipsis-horizontal"></i>
                </span>
                <mat-menu #statusMenuMobile="matMenu" xPosition="before">
                  <button mat-menu-item (click)="onPanelStopSales(event)"
                    *ngIf="event.active !== false && event.active_sales !== false && event.sold_out !== true && event.cancelled !== true"
                    [disabled]="loadingStateChange[event.id]">
                    <i class="fa-light fa-pause"></i> Parar ventas
                  </button>
                  <button mat-menu-item (click)="onPanelSoldOut(event)"
                    *ngIf="event.active !== false && event.active_sales !== false && event.sold_out !== true && event.cancelled !== true"
                    [disabled]="loadingStateChange[event.id]">
                    <i class="fa-light fa-users"></i> Aforo completo
                  </button>
                  <button mat-menu-item (click)="onPanelCancel(event)"
                    *ngIf="event.cancelled !== true && event.active !== false"
                    [disabled]="loadingStateChange[event.id]">
                    <i class="fa-light fa-ban"></i> Cancelar
                  </button>
                  <button mat-menu-item (click)="onPanelDeactivate(event)"
                    *ngIf="event.active !== false && event.cancelled !== true"
                    [disabled]="loadingStateChange[event.id]">
                    <i class="fa-light fa-eye-slash"></i> Desactivar
                  </button>
                  <button mat-menu-item (click)="onPanelRestore(event)"
                    *ngIf="event.active === false || event.sold_out === true || event.active_sales === false || event.cancelled === true"
                    [disabled]="loadingStateChange[event.id]">
                    <i class="fa-light fa-redo"></i> Restaurar
                  </button>
                </mat-menu>
              </div>
            </div>
            <div class="price-tag col-12">
              <span class="price-label">Desde</span>
              <span class="price-value">
                <ng-container *ngIf="event.external; else internalPrice">-</ng-container>
                <ng-template #internalPrice>{{event.custom_from_price ?? event.from_price}} €</ng-template>
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="pagination-component">
      <div class="d-flex align-items-center pagination-panel pagination-table" *ngIf="!loadingPage && !finishScroll">
        <div>
          <ng-lottie class="lottie-pagination" [options]="{path: 'assets/lotties/loading.json'}"
            containerClass="loading-box"></ng-lottie>
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="loaded && !loadingPage && eventos?.length <= 0" style="text-align: center; margin-top: 80px;">No hay
    {{draft ? 'borradores' : 'eventos'}} disponibles</p>
</div>
